import { createContext, Dispatch, useContext } from 'react';

import { AvailableLanguages } from 'common/hooks/useCurrentLanguage/types';

export interface LanguageContextType {
  lang: AvailableLanguages;
  setLang: Dispatch<AvailableLanguages>;
}

export const LanguageContext = createContext<LanguageContextType>({
  lang: 'fr',
  setLang: () => undefined,
});

export const useLanguageContext = () => {
  return useContext(LanguageContext);
};
